import { type PropsWithChildren } from 'react';

import { minValue } from './Min.sty.js';
import type { ComponentWithName } from '../../../../../../core/types/component-with-name.js';

export const Min = ({ children }: PropsWithChildren) =>
  children !== undefined ? <p className={minValue}>{children}</p> : null;

(Min as ComponentWithName<typeof Min>).displayName = 'MeterBarLayout.Min';
